var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { PaymentMethodTypes } from '../../enums/order-source-type';
import { PaymentProcessor } from './payment-processor.enum';
import { BaseSettings } from './base-settings.model';
var PaymentComponentSettings = /** @class */ (function (_super) {
    __extends(PaymentComponentSettings, _super);
    function PaymentComponentSettings() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.paymentMethodTypes = PaymentMethodTypes;
        _this.processorTypes = PaymentProcessor;
        _this.isAddNewCard = false;
        return _this;
    }
    return PaymentComponentSettings;
}(BaseSettings));
export { PaymentComponentSettings };



// WEBPACK FOOTER //
// ./src/app/customerservice/models/payments/payment.model.ts.pre-build-optimizer.js